import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class ReportQueryListItem extends SearchModelBase {
    id: number = 0;
    title: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Title', width: 300, dataIndex: 'title', defaultColumnFocus : true}),
    ];

    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };

    public static OrderBy = { orderBy: ReportQueryListItem.prototype.id, orderByAscending: false };

    public static formatData(data: ReportQueryListItem[]) {
        return data.map((d: ReportQueryListItem) => ({
          ...d,
        }));
    }
}
